module.exports = __webpack_public_path__ + "static/People1-3x-93edb45833d811653835508ffda0e9cc.png";